import { render, staticRenderFns } from "./SystemCard.vue?vue&type=template&id=7fa3b101&scoped=true&"
import script from "./SystemCard.vue?vue&type=script&lang=js&"
export * from "./SystemCard.vue?vue&type=script&lang=js&"
import style0 from "./SystemCard.vue?vue&type=style&index=0&id=7fa3b101&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3b101",
  null
  
)

export default component.exports